import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/',
  name: 'patientEducation',
  meta,
  redirect: { name: 'patient-education' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'patientEducation/patientList', name: `${pre}list`, component: () => import('@/pages/patientEducation/patientList'), meta: { meta, title: '患者教育' } },
    { path: 'patientEducation/addPatientEducation', name: `${pre}add`, component: () => import('@/pages/patientEducation/addPatientEducation'), meta: { meta, title: '新增' } },
    { path: 'patientEducation/editPatientEducation/:id', name: `${pre}edit`, component: () => import('@/pages/patientEducation/editPatientEducation'), meta: { meta, title: '编辑' } }
  ])('patientEducation-')
}
